// Week navigator for the Log view: ‹ prev / next › + the visible week's date
// range + "week X of Y".

import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { fmtUtc, translateLog } from "./viewTokens";

export const LogWeekNav = ({ startUtc, endUtc, weekNumber, totalWeeks, onPrev, onNext }) => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="np-log-week-nav">
      <button
        type="button"
        className="np-log-week-nav__arrow"
        onClick={onPrev}
        disabled={weekNumber <= 1}
      >
        ‹
      </button>
      <div className="np-log-week-nav__label">
        <div className="np-log-week-nav__range">
          {fmtUtc(startUtc)} – {fmtUtc(endUtc)}
        </div>
        <div className="np-log-week-nav__count">
          {translateLog(t, "weekOf", { current: weekNumber, total: totalWeeks })}
        </div>
      </div>
      <button
        type="button"
        className="np-log-week-nav__arrow"
        onClick={onNext}
        disabled={weekNumber >= totalWeeks}
      >
        ›
      </button>
    </div>
  );
};

LogWeekNav.propTypes = {
  startUtc: PropTypes.number,
  endUtc: PropTypes.number,
  weekNumber: PropTypes.number.isRequired,
  totalWeeks: PropTypes.number.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default LogWeekNav;
